










import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { LotTypes } from '~/enums/lots'
import DefaultImage from '~/mixins/defaultImage'
import { LotInfo, RentalUnit } from '~/models'

@Component({
  mixins: [DefaultImage],
})
export default class LotImage extends mixins(DefaultImage) {
  @Prop({ default: (): LotInfo => null })
  lotInfo: LotInfo

  @Prop({ default: (): RentalUnit => null })
  rentalUnit: RentalUnit

  @Prop({ default: '' }) lotType: string

  get title(): string {
    return this.lotInfo?.title || ''
  }

  get imageSrc(): string {
    if (this.lotType !== 'rental') {
      if (this.lotInfo === null) {
        return this.defaultImage()
      }

      const photo = this.lotInfo?.additional_photos?.length
        ? this.lotInfo.additional_photos[0]
        : undefined

      const photoKey =
        this.lotType === LotTypes.HOME_SITE
          ? 'homesite_photo'
          : 'listing_photo_url'

      return (
        photo ||
        this.lotInfo[photoKey] ||
        this.lotInfo.place_holder_thumbnail ||
        this.defaultImage()
      )
    } else if (this.rentalUnit?.images?.length > 0) {
      return this.rentalUnit.images[0].source
    } else {
      this.defaultImage()
    }
  }
}
